import MainLayout from "../layouts/MainLayout";
import PaymentFailed from "../pages/PaymentFailed";
import Main from "../pages/Main";
import PaymentSuccess from "../pages/PaymentSuccess";
import { useRoutes } from "react-router-dom";
export default function Routing() {
  const routes = [
    {
      path: "",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: <Main />,
        },
        {
          path: "payment-success",
          element: <PaymentSuccess />,
        },
        {
          path: "payment-fail",
          element: <PaymentFailed />,
        },
      ],
    },
    {
      path: "*",
      element: <MainLayout />,
      children: [
        {
          path: "*",
          element: <Main />,
        },
      ],
    },
  ];
  return useRoutes(routes);
}

